module.exports = __webpack_public_path__ + "static/media/AlertsNew.df5eda88.svg";